import requests from '../../../../redux/reducer/requests';
import { useDispatch } from 'react-redux';

export default function useServiceDataCallbacks() {
  const dispatch = useDispatch();

  return {
    getServiceData: () => dispatch(requests.thunks.getServiceData()),
  };
}
